import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {};
const mutations = {};
const getters = {};
const actions = {
  getActByExId({ rootState }, opt) {
    // 通过展会Id获取活动
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/activity/GetBackendByExhibition`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addAct({ rootState }, opt) {
    // 新增活动
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/activity`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getActById({ rootState }, id) {
    // 获取活动详情
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/activity/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editActInfo({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/activity`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },
  editActTopic({ rootState }, opt) {
    // 设置置顶方式
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/activity/SetTopic`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },
  editActShow({ rootState }, opt) {
    // 设置屏蔽/显示
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/activity/SetShow`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },
  delActById({ rootState }, id) {
    // 删除活动
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/activity?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  //获取展会配置
  getShareUrl({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/DeExCardPlanConfigExhibition/GetByExhibitionId`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
